<!-- <div class="p-grid">
  <h3 class="subtitle p-col-12 p-md-6 p-lg-4 p-lg-offset-1">Choisissez un produit et nous vous mettrons en contact avec un expert par téléphone, par chat, par email</h3>
</div>
<ul class="contentview p-grid p-justify-around">
  <li  (click)="matSelected(1,'IxellColorWeb')" class="balance p-col-12 p-md-6 p-lg-4"><img src="assets/balance/IxellColorWeb.png" alt=""/></li>
  <li  (click)="matSelected(2,'IxellColorTouch')" class="balance p-col-12 p-md-6 p-lg-4"><img src="assets/balance/IxellColorTouch1.png" alt=""/></li>
  <li  (click)="matSelected(3,'IxellColorConnect')" class="balance p-col-12 p-md-6 p-lg-4"><img src="assets/balance/IxellColorConnect1.png" alt=""/></li>
</ul> -->
<div class="pageContainer contentHeight">
    <h3 class="col-12 containerTitle" [translate]="'support.intro'"></h3>
    <div class="">

        <!--<div  *ngIf="Utils.isUserIxell(role) || Utils.isCTC(role)" class="scale">
          <div class="cardHome backgroundWhiteRound" routerLink="/actionmateriel"  (click)="selectScale(1,'IxellColorWeb')">
            <img src="assets/balance/IxellColorWeb.png" alt=""/>
          </div>
        </div>
        <div *ngIf="!Utils.isUserIxell(role) && !Utils.isCTC(role)" class="scale">
          <div *ngIf="!Utils.isAttum(role)" class="cardHome overlay backgroundWhiteRound">
            <img src="assets/balance/IxellColorWeb.png" class="imgInactif" alt=""/>
          </div>
          <div *ngIf="Utils.isAttum(role)" class="cardHome backgroundWhiteRound">
            <img  src="assets/balance/IxellColorWeb.png" alt=""/>
          </div>
        </div>-->

        <div class="row mx-auto balRow">
            <!--<div *ngIf="Utils.isUserIxell(role) || Utils.isCTC(role)" class="scale">
                <div class="cardHome backgroundWhiteRound" routerLink="/actionmateriel" (click)="selectScale(2,'IxellColorTouch')">
                    <img src="assets/balance/IxellColorTouch1.png" alt="" />
                </div>
            </div>

            <div *ngIf="!Utils.isUserIxell(role) && !Utils.isCTC(role)" class="scale">
                <div *ngIf="!Utils.isAttum(role)" class="cardHome overlay backgroundWhiteRound">
                    <img src="assets/balance/IxellColorTouch1.png" class="imgInactif" alt="" />
                </div>
                <div *ngIf="Utils.isAttum(role)" class="cardHome backgroundWhiteRound">
                    <img src="assets/balance/IxellColorTouch1.png" alt="" />
                </div>
            </div>-->

            <div class="scale">
                <div *ngIf="!Utils.isAttum(role)" class="cardHome backgroundWhiteRound" routerLink="/actionmateriel" (click)="selectScale(4,'IxellColorConnect')">
                    <img src="assets/balance/IxellColorConnect1.png" alt="" />
                </div>
                <div *ngIf="Utils.isAttum(role)" class="cardHome backgroundWhiteRound">
                    <img src="assets/balance/IxellColorConnect1.png" alt="" />
                </div>
            </div>

            <div class="scale">
                <div *ngIf="!Utils.isAttum(role)" class="cardHome backgroundWhiteRound" routerLink="/actionmateriel" (click)="selectScale(8,'IxellColorPro')">
                    <img src="assets/balance/IxellcolorPro.png" alt="" />
                </div>
                <div *ngIf="Utils.isAttum(role)" class="cardHome backgroundWhiteRound">
                    <img src="assets/balance/IxellcolorPro.png" alt="" />
                </div>
            </div>
        </div>


        <div class="row mx-auto balRow">
            <div *ngIf="!Utils.isAttum(role) && !Utils.isCTC(role)" class="scale">
                <div class="cardHome overlay backgroundWhiteRound">
                    <img src="assets/balance/balance1.png" class="imgInactif" alt="" />
                </div>
            </div>

            <div *ngIf="Utils.isAttum(role) || Utils.isCTC(role)" class="scale">
                <!-- <div class="cardHome overlay" (click)="selectScale(4,'XXX')> -->
                <div class="cardHome backgroundWhiteRound">
                    <a (click)="openAttum()">
                        <img src="assets/balance/balance1.png" alt="" />
                    </a>
                </div>
            </div>

            <div *ngIf="!Utils.isAttum(role) && !Utils.isCTC(role)" class="scale">
                <div class="cardHome overlay backgroundWhiteRound">
                    <img src="assets/balance/balance2.png" class="imgInactif" alt="" />
                </div>
            </div>

            <div *ngIf="Utils.isAttum(role) || Utils.isCTC(role)" class="scale">
                <div class="cardHome backgroundWhiteRound">
                    <a (click)="openAttum()">
                        <img src="assets/balance/balance2.png" alt="" />
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>

<!--
<div class="col-lg-4 col-md-6 col-sm-6 mt-3 mx-auto ">
    <div class="colorwebTech cardHome overlay">
    <div class="colorwebTech cardHome overlay" (click)="launchColorwebtech()">
      <h3 [translate]="'home.colorwebtechTitle'" class="mt-2 text-secondary"></h3>
      <div class="inactifRect"></div>
      <div class="purpleRect"></div>
      <img src="assets/colorwebtech-round.png" alt=""/>
      <label class="name mt-2 text-secondary">Colorwebtech</label>
    </div>
  </div> -->
